import React, {useState} from 'react';
import {connect} from 'react-redux';
import {Flex, SVGButton, SVG, Modal, TextInput, Arrow} from '/app/src/component';

import {FAQModel} from '/app/src/model'

const AddCategoryModal = ({open, onClose, ...props}) => {

    const [index, setIndex] = useState(0)
    const [selected, setSelected] = useState(null)
    const [input, setInput] = useState(null)

    const [titleRequire, setTitleRequire] = useState(false)
    const [iconRequire, setIconRequire] = useState(false)

    const icons = [ 'HelpdeskCategories_Book_L.svg',
                    'HelpdeskCategories_Calender_L.svg',
                    'HelpdeskCategories_Code_L.svg',
                    'HelpdeskCategories_Company_L.svg',
                    'HelpdeskCategories_Confused_L.svg',
                    'HelpdeskCategories_CreditCard_L.svg',
                    'HelpdeskCategories_Customize_L.svg',
                    'HelpdeskCategories_Delete_L.svg',
                    'HelpdeskCategories_Discount_L.svg',
                    'HelpdeskCategories_Download_L.svg',
                    'HelpdeskCategories_Employees_L.svg',
                    'HelpdeskCategories_Frontdesk_L.svg',
                    'HelpdeskCategories_Images_L.svg',
                    'HelpdeskCategories_Invoice_L.svg',
                    'HelpdeskCategories_Location_L.svg',
                    'HelpdeskCategories_Mail_L.svg',
                    'HelpdeskCategories_Mobile_L.svg',
                    'HelpdeskCategories_Negative_L.svg',
                    'HelpdeskCategories_Password_L.svg',
                    'HelpdeskCategories_People_L.svg',
                    'HelpdeskCategories_Phone_L.svg',
                    'HelpdeskCategories_Positive_L.svg',
                    'HelpdeskCategories_Questions_L.svg',
                    'HelpdeskCategories_Settings_L.svg',
                    'HelpdeskCategories_Shipment_L.svg',
                    'HelpdeskCategories_ShipmentReturn_L.svg',
                    'HelpdeskCategories_Statistics_L.svg',
                    'HelpdeskCategories_Tags_L.svg',
                    'HelpdeskCategories_Tickets_L.svg',
                    'HelpdeskCategories_Time_L.svg',
                    'HelpdeskCategories_Tools_L.svg',
                    'HelpdeskCategories_Truck_L.svg',
                    'Menu_ClientChat_Profile_L.svg',
    ]
    const resetState = ()=>{
        setIndex(0); setSelected(null);setInput(null);setTitleRequire(false);setIconRequire(false)
    }
    const onSaveButtonClick = ()=>{
        var error = false
       if(selected === null){
           setIconRequire(true);
           error=true
       }else{
           setIconRequire(false)
       }
       if (typeof input === 'undefined' || !input || input.length === 0 || input === "" || !/[^\s]/.test(input) || /^\s*$/.test(input) || input.replace(/\s/g,"") === ""){
           setTitleRequire(true);
           error=true
       }else{
           setTitleRequire(false)
       }
       if(!error){
           props.createCategory(input, icons[selected])
           resetState()
           onClose()
       }
    }
    const onCancelButtonClick = ()=>{
        resetState()
        onClose()
    }
    return (
        <Modal
            title='Lägg till kategori'
            open={open}
            onClose={onClose}
        >
            <Flex column w='100%' hAlignContent='center' my='25px'>
            <Flex color='black' fontSize='24px' fontWeight='300' >
                Titel
                {titleRequire &&
                <SVG cacheGetRequests={true} style={{'fill': '#ff4e00', 'height': '15px', 'width': '15px', 'marginLeft': '5px'}}
                src='/images/Required_Star.svg'/>}
            </Flex>
            <Flex w='50%' mt='20px'><TextInput maxLength='20' value={input} onChange={(event)=>{setInput(event.target.value)}}/></Flex>
            <Flex fontSize='24px' fontWeight='300' mt='30px' mb='10px'>Visningsikon
            {iconRequire &&

            <SVG cacheGetRequests={true} style={{'fill': '#ff4e00', 'height': '15px', 'width': '15px', 'marginLeft': '5px'}}
            src='/images/Required_Star.svg'/>}
            </Flex>
            <Flex>
                <Arrow direction='left' onClick={()=>{
                        if(index !==0){
                            setIndex(index-1)
                        }
                    }
                }/>

                {icons.map((icon, i) => {
                    // use display instead of render for faster render
                    const visible = index <= i && i < index+5
                    const isSelected = selected === i
                    const imgSrc=`https://storage.googleapis.com/jibber-image/images/${icon}`
                    return (
                        <Flex center mx='2px' cursor='pointer'
                            backgroundHover={isSelected?'none':'darkwhite'}
                            backgroundColor={isSelected?'lightblue':'white'}
                            border={isSelected?'3px solid #2ea2d2': 'none'}
                            onClick={()=>{setSelected(i)}}
                            display={!visible&&'none'}
                            key={i}
                            w='131px' h='131px' borderRadius='20px'>
                                <SVG cacheGetRequests={true} style={{'fill': '#2ea2d2', 'height': '94px', 'width': '94px'}}
                                src={imgSrc}/>
                        </Flex>
                    )
                })}
                <Arrow direction='right' onClick={()=>{
                        if(index < icons.length-5){
                            setIndex(index + 1)
                        }}}
                />
            </Flex>
            <Flex column>
                <Flex h='50px' column center mb='10px'>
                    {titleRequire && <Flex color='#ff4e00' fontSize='18px' fontWeight='500' my='5px'>* Kategorin saknar titel!</Flex>}
                    {iconRequire && <Flex color='#ff4e00' fontSize='18px' fontWeight='500' my='5px'>* Kategorin saknar icon!</Flex>}
                </Flex>
                <Flex>
                    <SVGButton text='Avbryt' src='/images/Return.svg' border fontSize='26px'  mr='20px'
                    onClick={onCancelButtonClick}
                    hover='blue'
                    />
                    <SVGButton text='Skapa' src='/images/Save.svg' border  fontSize='26px' 
                    onClick={onSaveButtonClick}
                    hover='blue'
                    />
                </Flex>
            </Flex>
            </Flex>
        </Modal>
    )
}

const {selector: createCategorySelector, dispatcher: createCategoryDispatch} = FAQModel.createCategoryRequest()

const mapDispatchToProps = (dispatch, props) => ({
    createCategory: (category, imgSrc)=>dispatch(createCategoryDispatch(category, imgSrc))
})
function mapStateToProps(state, props){
    const {network} = createCategorySelector(state)
    return {
        network: network.toJS(),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AddCategoryModal)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Helpdesk/Categories/AddCategoryModal.js